import React, { Suspense } from "react"
import Content from "./Content/Content"
import Section from "./Section/Section"
import Float from "./Float/Float"
import BlurBackground, {
  BlurBackgroundProps,
} from "./BlurBackground/BlurBackground"
import useDeviceType from "../../../hooks/useDeviceType"
import elementSplitter from "./utils/elementSplitter"

const SwipeGallery = React.lazy(() => import("./SwipeGallery/SwipeGallery"))

type WidgetListsProps = {
  children: React.ReactElement
  topSpace?: number | string
  backgroundType: BlurBackgroundProps["type"]
}

const WidgetLists = ({
  children,
  topSpace = 100,
  backgroundType,
}: WidgetListsProps) => {
  //
  const DeviceType = useDeviceType()

  const { headers, svgs, components } = elementSplitter(children)

  // Decorative SVG
  const decorativeSVG = svgs[0] && (
    <Float right={230} bottom={-60} removeResponsive>
      <>
        {React.cloneElement(svgs[0] as React.ReactElement, {
          style: { ...svgs[0].props.style, transform: "rotate(155deg)" },
        })}
      </>
    </Float>
  )

  return (
    <Content topSpace={topSpace} gap={40}>
      <Section y="bottom" style={{ marginBottom: "30px" }}>
        {headers[0]}
        {decorativeSVG}
      </Section>

      <Suspense fallback={<h4>Loading...</h4>}>
        <SwipeGallery>
          {DeviceType === "mobile" || DeviceType === "tablet" ? (
            <Section>{components.slice(0, -1)}</Section>
          ) : (
            <Section>{components}</Section>
          )}
        </SwipeGallery>
      </Suspense>

      {backgroundType && (
        <BlurBackground direction="center" type={backgroundType} />
      )}
    </Content>
  )
}

export default WidgetLists
